import { envService } from '@/core/services/env'
import { httpClient } from '@/core/services/http'
import { unstable_cache } from 'next/cache'
import { createGetFaqUseCase } from '../use-cases/get-faqs.usecase'
import { createGetPlaceDetailsUseCase } from '../use-cases/get-place.usecase'
import { createGetPrivacyPolicyUseCase } from '../use-cases/get-privacy-policy.usecase'
import { createGetAppSettingsUseCase } from '../use-cases/get-settings.usecase'
import { createGetSlidersUseCase } from '../use-cases/get-sliders.usecase'
import { createGetSupportNumberUseCase } from '../use-cases/get-support-number.usecase'
import { createGetTermsAndConditionsUseCase } from '../use-cases/get-terms-and-conditions.usecase'
import { createSendContactMessageUseCase } from '../use-cases/send-contact-message.usecase'

export const getAppSettings = unstable_cache(
  createGetAppSettingsUseCase({ httpClient }),
  ['app-settings'],
  { revalidate: 7200 },
)

export const getPlaceDetails = unstable_cache(
  createGetPlaceDetailsUseCase({ httpClient, envService }),
  ['place-details'],
  { revalidate: 7200 },
)

export const getSupportNumber = unstable_cache(
  createGetSupportNumberUseCase({ httpClient }),
  ['support-number'],
  { revalidate: 7200 },
)

export const getSliders = unstable_cache(
  createGetSlidersUseCase({ httpClient }),
  ['sliders'],
  { revalidate: 5 }, // TODO: UPDATE REVALIDATE TIME AFTER TESTING
)

export const getPrivacyPolicy = unstable_cache(
  createGetPrivacyPolicyUseCase({ httpClient }),
  ['privacy-policy'],
  { revalidate: 7200 },
)

export const getTermsAndConditions = unstable_cache(
  createGetTermsAndConditionsUseCase({ httpClient }),
  ['terms-and-conditions'],
  { revalidate: 7200 },
)

export const getFaqs = unstable_cache(
  createGetFaqUseCase({ httpClient }),
  ['faqs'],
  { revalidate: 7200 },
)

export const sendContactMessage = createSendContactMessageUseCase({
  httpClient,
})
